export default __webpack_public_path__ + "static/media/kitchen5-afterD-1440w.56687422.png";